import { jsx as _jsx } from "react/jsx-runtime";
import svgIconClasses from "@mui/material/SvgIcon/svgIconClasses";
import checkboxClasses from "@mui/material/Checkbox/checkboxClasses";
import createSvgIcon from "@mui/material/utils/createSvgIcon";
import formControlLabelClasses from "@mui/material/FormControlLabel/formControlLabelClasses";
export const MuiCheckboxTheme = (dt) => {
    const colorStyle = (color) => {
        return {
            [` .${svgIconClasses.root}`]: {
                background: dt.color.surface.key,
            },
            [`&.Mui-focusVisible .${svgIconClasses.root}, input:focus ~ .${svgIconClasses.root}, &:is(.Pxl-demo-focus, [data-demostate=focus])[class] .${svgIconClasses.root}`]: {
                boxShadow: `${dt.state.focus[color]}, inset 0 0 0 ${dt.input.shape.border} ${dt.color.onSurface.key}`,
            },
            [`input:active ~ .${svgIconClasses.root}, &:is(.Pxl-demo-active, [data-demostate=active]) .${svgIconClasses.root}`]: {
                backgroundColor: dt.cta.outlined.color.background[color].pressed,
            },
            [`&.${checkboxClasses.disabled}[class] .${svgIconClasses.root}`]: {
                boxShadow: `inset 0 0 0 ${dt.input.shape.border} ${dt.cta.outlined.color.border[color].disabled}`,
                backgroundColor: dt.color.surface.key,
            },
            [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
                [`.${svgIconClasses.root}`]: {
                    backgroundColor: dt.cta.contained.color.background[color].active,
                    boxShadow: "none",
                },
                [`input:hover ~ .${svgIconClasses.root}, &:is(.Pxl-demo-hover, [data-demostate=hover]) .${svgIconClasses.root}`]: {
                    backgroundColor: dt.cta.contained.color.background[color].hover,
                    boxShadow: "none",
                },
                [`input:focus ~ .${svgIconClasses.root}, &:is(.Pxl-demo-focus, [data-demostate=focus])[class] .${svgIconClasses.root}`]: {
                    backgroundColor: dt.cta.contained.color.background[color].focus,
                    boxShadow: dt.state.focus[color],
                },
                [`input:active ~ .${svgIconClasses.root}, &:is(.Pxl-demo-active, [data-demostate=active]) .${svgIconClasses.root}`]: {
                    backgroundColor: dt.cta.contained.color.background[color].pressed,
                },
                [`.${svgIconClasses.root} .tick, .stroke`]: {
                    fill: dt.cta.contained.color.text[color].default,
                },
                [`&.${checkboxClasses.disabled}`]: {
                    [`.${svgIconClasses.root}`]: {
                        backgroundColor: dt.cta.contained.color.background[color].disabled,
                        boxShadow: "none",
                        ".tick, .stroke": {
                            fill: dt.cta.contained.color.text[color].default,
                        },
                    },
                },
            },
        };
    };
    const PixelCheckbox = createSvgIcon(null, "PixelCheckbox");
    const PixelCheckboxChecked = createSvgIcon(_jsx("path", { className: "tick", d: "M8.8,15.9l-3.5-3.5c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L8.1,18c0.4,0.4,1,0.4,1.4,0L20.1,7.4\n    c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L8.8,15.9z" }), "PixelCheckboxChecked");
    const PixelCheckboxIndetermined = createSvgIcon(_jsx("path", { className: "stroke", d: "M7,11h10c0.5,0,1,0.4,1,1c0,0.6-0.5,1-1,1H7c-0.5,0-1-0.5-1-1C6,11.5,6.4,11,7,11z" }), "PixelCheckboxIndetermined");
    return {
        defaultProps: {
            disableRipple: true,
            icon: _jsx(PixelCheckbox, {}), // depracated
            checkedIcon: _jsx(PixelCheckboxChecked, {}), // depracated
            indeterminateIcon: _jsx(PixelCheckboxIndetermined, {}), // depracated
        },
        styleOverrides: {
            root: Object.assign({ paddingRight: dt.button.gap, [`& .${svgIconClasses.root}`]: {
                    borderRadius: dt.input.shape.borderRadius,
                    width: dt.action.default,
                    height: dt.action.default,
                    boxShadow: `inset 0 0 0 ${dt.input.shape.border} ${dt.color.outline}`,
                    [`.${svgIconClasses.root}-iconUnchecked`]: {
                        fill: dt.color.surface.key,
                    },
                }, [`.${formControlLabelClasses.root} + .${formControlLabelClasses.label}`]: {
                    marginBottom: 0,
                }, [`input:hover ~ .${svgIconClasses.root}, &:is(.Pxl-demo-hover, [data-demostate=hover]) .${svgIconClasses.root}`]: {
                    boxShadow: `inset 0 0 0 ${dt.input.shape.border} ${dt.color.onSurface.key}`,
                } }, colorStyle("primary")),
            colorSecondary: colorStyle("secondary"),
        },
    };
};
